import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const HighchartsGraph = () => {
  useEffect(() => {
    Highcharts.chart('container', {
      title: {
        text: 'Assests download',
      },
      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function () {
            return Highcharts.dateFormat('%e-%b-%Y', this.value);
          },
        },
        accessibility: {
          rangeDescription: 'Range: 1 to 10',
        },
      },
      yAxis: {
        type: 'linear',
        min: 1,  // Set the minimum value for the y-axis
        max: 10, // Set the maximum value for the y-axis
       
      },
     
      series: [
        {
          data: [
            [Date.UTC(2024, 1, 9), 1],
            [Date.UTC(2024, 1, 10), 2],
            [Date.UTC(2024, 1, 11), 3],
            [Date.UTC(2024, 1, 12), 4],
            [Date.UTC(2024, 1, 13), 5],
            [Date.UTC(2024, 1, 14), 6],
            [Date.UTC(2024, 1, 15), 7],
            [Date.UTC(2024, 1, 16), 8],
            [Date.UTC(2024, 1, 17), 9],
            [Date.UTC(2024, 1, 18), 10],
            
          ],
          pointStart: Date.UTC(2024, 1, 9),
        
        },
      ],
    });
  }, []);

  return <div id="container" style={{ width: '60%', height: '120%' }} />;
};

export default HighchartsGraph;
